<template> 
  <section class="hero is-medium">
    <b-loading :active="isLoading" @update:active="isLoading = $event"></b-loading>
    <div class="hero-body">
      <div class="container has-text-centered">
        <img alt="FLORENSE" width="300" src="../assets/logo.png">
        <h2 class="subtitle">
          {{$t('SOBRE.APRESENTACAO')}}
        </h2>    
        <h2 class="subtitle">
          <span class="tag is-black">{{$t('SOBRE.VERSAO')}} {{config.releaseNumber}}</span>
          <span class="tag is-info">{{config.releaseDate}}</span>
        </h2>
      </div>
    </div>
  </section>
</template>

<style scoped>
.cardAtendimento {
    background-color: #fff;
    cursor: pointer;
}

.cardAtendimento:hover {
    background-color: hsl(0, 0%, 96%)
}
</style>

<script>
    import http from '@/http'
    import { mapState } from 'vuex'
    import modalNotificacao from '@/components/modalNotificacao.vue'    

    export default {

      data() {
            return {
              bloquearUsuarioMenu:false,
              listaAtrasados:[],
              isLoading:false,
            }
        },      
        computed: {
            ...mapState([
                'unidadeId',
                'config',
                'usuario',
                'componentes'
            ]),
        },

        methods:{
        
 
          abrirModalNotificacao() {

                const existingModal = document.querySelector('.modal'); 
                if(!existingModal){
                  this.$buefy.modal.open({
                        parent: this,
                        component: modalNotificacao,                                                      
                        hasModalCard: true,
                        trapFocus: true,                    
                        canCancel: false
                    })              

                }            
            
          },

          loadTotalNotificacoesFuncionario() {


                  http.get('/api/notificacao/RetornaTotalMensagensFuncionario?funcionarioId=' + this.usuario.funcionarioId )
                      .then(res => res.data)
                      .then(data => {   
                      
                        if(data>0){
                          this.abrirModalNotificacao();
                        }else{
              
                            http.get('/api/notificacao/retornaTotalNotificacoesFuncionario?funcionarioId=' + this.usuario.funcionarioId )
                                    .then(res => res.data)
                                    .then(data => {     
                                                                    
                                    if(data>0)
                                      this.abrirModalNotificacao();
                                })
                                .catch((error) => {                        
                                    throw error
                                });                            
                        }
                          
                                                                          
                  })
                  .catch((error) => {                        
                      throw error
                  });
                  
                  
                  
              
          }, 
      
                                 
        },
        mounted() {                        
            this.loadTotalNotificacoesFuncionario();
          

        },

        
             
    }
</script>
